import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Dialog, Transition } from "@headlessui/react";
import Input from "../../inputs/inputs";
import Button from "../../buttons/buttons";
import CLOSE from "../../../assets/images/icons/close.svg";
import { ReactComponent as UploadIcon } from "../../../assets/images/icons/upload.svg";
import { Beat } from "../../../plugins/spinners.plugin";
import { cleanInput } from "../../../helpers/cleanInput";
import { history } from "../../../helpers/history";
import { editAdvertisment } from "../../../redux/advertisment/advertismentAction";

export default function EditSlider({ advert }) {
  const dispatch = useDispatch();
  const hiddenFileInput = useRef(null);
  const [submitted, setSubmitted] = useState(false);
  const [images, setImages] = useState([]);
  const [imageUrls, setImageUrls] = useState([]);
  const [image64, setImage64] = useState({});
  const { isLoading } = useSelector((state) => state.advertisment);
  let [isOpen, setIsOpen] = useState(false);
  console.log('advert,advert', advert);


  const [data, setData] = useState({
    id: advert.id,
    title: "",
    url: "",
    description: "",
    base64_photos: "",
  });
  const { title, url } = data;

  function onImageChange(e) {
    setImages([...e.target.files]);
    let reader = new FileReader();
    reader.readAsDataURL(e.target.files[0]);
    reader.onloadend = () => {
      setImage64(reader.result);
    };
  }
  const handleFileClick = (event) => {
    event.preventDefault();
    hiddenFileInput.current.click();
  };
  useEffect(() => {
    // Update the document title using the browser API
    let dataObject = {
      id: advert?.id,
      title: advert?.title,
      url: advert?.url,
      description: advert?.description,
    };

    setData({ ...dataObject });

    // Set the existing image URL if available
    if (advert?.pictures && advert.pictures.length > 0) {
      setImageUrls([advert.pictures[0]]);
    }
  }, [advert]);

  useEffect(() => {
    if (images.length < 1) return;
    const newImageUrls = [];
    images.forEach((image) => newImageUrls.push(URL.createObjectURL(image)));
    setImageUrls(newImageUrls);
  }, [images]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setData((data) => ({ ...data, [name]: value }));
  };
  function handleClose() {
    setIsOpen(false);
  }

  console.log('data', data);

  const handleSubmit = async () => {
    setSubmitted(true);
    if (title && url) {
      // Include base64_photos only if a new image was selected
      const updateData = { ...data };
      if (image64 && Object.keys(image64).length > 0) {
        updateData.base64_photos = [image64];
      }
      
      // Clean the data but preserve the id
      const id = updateData.id;
      cleanInput(updateData);
      updateData.id = id;

      // dispatch action to create data
      const response = await dispatch(editAdvertisment(updateData));
      if (response?.status === "success") {
        history("/admin/settings/sliders/1");
        handleClose();
      }
    }
  };
  return (
    <div>
      <Button.Primary title={"Edit Slider"} onClick={() => setIsOpen(true)} />
      <Transition appear show={isOpen}>
        <Dialog as="div" className="relative z-10" onClose={handleClose}>
          <Transition.Child
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-center sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
              <Transition.Child
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="bg-white dark:bg-[#121212] w-[380px] text-left sm:w-[630px] p-4 sm:p-6">
                  <div>
                    <div className=" sm:block absolute top-3 right-2 pt-4 pr-4">
                      <button
                        type="button"
                        className="bg-[#ffeae5] rounded-md p-1 sm:p-3 "
                        onClick={handleClose}
                      >
                        <span className="sr-only">Close</span>
                        <img
                          src={CLOSE}
                          alt="close"
                          className=" w-3 h-3 sm:w-4 sm:h-4"
                        />
                      </button>
                    </div>

                    <div className="pb-5 text-center sm:mt-2 sm:text-center border-b border-[#E4E4F3] dark:border-[#505050]">
                      <Dialog.Title
                        as="h3"
                        className="text-xl font-bold text-black dark:text-white"
                      >
                        Edit Slider
                      </Dialog.Title>
                    </div>
                  </div>
                  <form id="slider_form" className="py-5 mt-4 px-5">
                    <Input.Label
                      title={"Title"}
                      name="title"
                      id="title"
                      defaultValue={data.title}
                      onChange={handleChange}
                    />
                    {submitted && !title && (
                      <div className="text-primary text-xs ">
                        Title is required
                      </div>
                    )}
                    <Input.Label
                      title={"Description"}
                      name="description"
                      id="description"
                      defaultValue={data.description}
                      placeholder="Enter description"
                      onChange={handleChange}
                    />
                    <Input.Label
                      title={"Link/URL"}
                      name="url"
                      id="url"
                      defaultValue={data.url}
                      placeholder="Enter URL"
                      onChange={handleChange}
                    />

                    <div className="mt-8 mx-auto text-center max-w-[298px] bg-[#FFFBFA] dark:bg-black p-5 border border-dashed border-[#E4E4F3] dark:border-[#505050] rounded-md cursor-pointer">
                      {imageUrls?.length > 0 ? (
                        <div>
                          {imageUrls?.map((image, index) => (
                            <div key={index}>
                              <img
                                src={image}
                                className="object-cover w-full h-full rounded-md"
                                alt="slider"
                              />
                            </div>
                          ))}
                          <p
                            className="text-[#676565] dark:text-white mt-3 cursor-pointer hover:underline"
                            onClick={handleFileClick}
                          >
                            Click to change photo
                          </p>
                          <input
                            type="file"
                            className="hidden"
                            accept="image/*"
                            onChange={onImageChange}
                            ref={hiddenFileInput}
                          />
                        </div>
                      ) : (
                        <div>
                          <UploadIcon className="w-8 h-8 mx-auto mb-3" />
                          <p
                            className="text-[#676565] dark:text-white"
                            onClick={handleFileClick}
                          >
                            Click here to select a photo
                          </p>
                          <input
                            type="file"
                            className="hidden"
                            accept="image/*"
                            onChange={onImageChange}
                            ref={hiddenFileInput}
                          />
                        </div>
                      )}
                    </div>
                  </form>

                  <div className="py-8 max-w-3xl mx-auto text-center">
                    <Button.Primary
                      title={isLoading ? <Beat /> : "Edit Slider"}
                      className="px-4"
                      type={"button"}
                      onClick={() => handleSubmit()}
                    />
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </div>
  );
}
